// {top, left} px strings keeping a fixed-position menu on-screen — flips above/left on overflow.
export function clampFixedMenuToViewport(clientX, clientY, menuSize, options = {}) {
  const { width, height } = menuSize;
  const padding = options.padding ?? 8;
  const preferredTop = options.preferredTop ?? clientY;

  const overflowsBottom = preferredTop + height > window.innerHeight - padding;
  const top = overflowsBottom ? Math.max(padding, clientY - height) : Math.max(padding, preferredTop);

  const overflowsRight = clientX + width > window.innerWidth - padding;
  const left = overflowsRight ? Math.max(padding, window.innerWidth - width - padding) : clientX;

  return { top: `${top}px`, left: `${left}px` };
}
